import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {convertSecondsToMMSSFormat} from '@Utils/date.util';
import {CurrentTimeText} from '@Components/poster-editor/components/poster-seekbar/components/current-time-text';
import {getPosterDuration, updateIsTimelineModeActive} from '@Components/poster-editor/poster-editor-reducer';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import {DurationSelector} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/components/duration-selector/duration-selector';
import styles from './play-button.module.scss';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {IconPlayPause} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/components/icon-play-pause/icon-play-pause';
import {onPosterPause, onPosterPlay} from '@Components/poster-editor/library/poster-editor-library';

export function PlayButton(): ReactElement<any> | null {
  const posterDuration = useAppSelector(getPosterDuration);
  const dispatch = useAppDispatch();

  const getTotalTime = (): ReactElement<any> => {
    return <Text val={convertSecondsToMMSSFormat(posterDuration)} size={TextSize.XXSMALL} />;
  };

  const getCurrentTime = (): ReactElement<any> => {
    return <CurrentTimeText />;
  };

  const getDurationOption = (): ReactElement<any> => {
    return (
      <div className={`${styles.durationContainerWrapper} _overflow-hidden  radius-4`}>
        <ClickableDiv
          onClick={(): void => {
            window.posterEditor?.whiteboard?.audioClips.unselectAudioPlaylist();
            dispatch(updateIsTimelineModeActive(false));
          }}
          className={`${styles.durationContainer} hover-transition-all _fit-width hover-transition-all radius-4 spacing-p-l-2 spacing-p-r-2 flex-h-row flex-items-center`}
        >
          {getCurrentTime()}
          {getTotalTime()}
        </ClickableDiv>
      </div>
    );
  };

  const getDropdownForDuration = (): ReactElement<any> => {
    return <DurationSelector />;
  };

  const onPlayPauseClick = (shouldPlay: boolean): void => {
    if (shouldPlay) {
      onPosterPlay();
    } else {
      onPosterPause();
    }
  };

  return (
    <div className="flex flex-row-align-center _fit-width">
      <IconPlayPause onClick={onPlayPauseClick} />
      {getDurationOption()}
      <div className={`${styles.divider} spacing-m-r-2 spacing-m-l-2`} />
      {getDropdownForDuration()}
    </div>
  );
}
